import { LiveVideoFlight, Project } from "@nova/protobuf"
import { dateAsNumber } from "../../util"
import {
    booleanValidator,
    genericCreateLayerValidator,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"

const saveRecordingValidator = {
    validators: booleanValidator("saveRecording"),
    nonNull: true,
} as const

export const createLiveVideoFlightValidator = {
    ...genericCreateLayerValidator,
    saveRecording: saveRecordingValidator,
    isMMA: { validators: booleanValidator("isMMA") },
}
export const updateLiveVideoFlightValidator = updateLayerValidator(LiveVideoFlight, {
    saveRecording: saveRecordingValidator,
})

export const getDefaultLiveVideoFlightCreateArgs = (project: Project, inParentId?: string) => ({
    visible: true,
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    // parentId would never got autopopulated
    parentId: undefined,
    live: false,
})

export type CreateLiveVideoFlightArgs = UnionToTuple<keyof typeof createLiveVideoFlightValidator>
export type UpdateLiveVideoFlightArgs = UnionToTuple<keyof typeof updateLiveVideoFlightValidator>
